import { render, staticRenderFns } from "./lessonDesc.vue?vue&type=template&id=f872ba72&"
import script from "./lessonDesc.vue?vue&type=script&lang=ts&"
export * from "./lessonDesc.vue?vue&type=script&lang=ts&"
import style0 from "./lessonDesc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports